import { render, staticRenderFns } from "./RecordHead.vue?vue&type=template&id=50a670b0&scoped=true"
import script from "./RecordHead.vue?vue&type=script&lang=js"
export * from "./RecordHead.vue?vue&type=script&lang=js"
import style0 from "./RecordHead.vue?vue&type=style&index=0&id=50a670b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a670b0",
  null
  
)

export default component.exports